import {handicaddieAsyncThunk} from "../../asyncThunk";
import {Club, ClubService, GetClubsResponse} from "../../../api/ClubService";
import {SessionState} from "../session/slice";
import {CaddieMaster} from "../../../api/CaddieMasterService";

export const loadClubs = handicaddieAsyncThunk(
    "Clubs/loadClubs",
    async (_, thunkAPI) => {
        let state = thunkAPI.getState();

        if (state.session.sessionState !== SessionState.ACTIVE) {
            return {};
        }

        let userId = state.session.user?.id
        if ((state.clubs.allClubs && state.clubs.allClubs.length > 0) || !userId) {
            thunkAPI.abort()
            return {}
        }

        let clResp: GetClubsResponse = await ClubService().getClubs()

        if (clResp.error) {
            return {}
        }

        if (!clResp.clubs) {
            return {}
        }

        let stateCms = state.session.caddieMasters
        if (!stateCms) {
            return {}
        }

        let clubs: Club[] = clResp.clubs
        let caddieMasters: CaddieMaster[] = stateCms

        let caddieMasterClubs: Club[] = clubs.filter((club: Club) =>
            caddieMasters.map((cm: CaddieMaster) => cm.clubId)
                .includes(club.id))

        let selectedClub: Club|undefined = undefined

        if (caddieMasterClubs && caddieMasterClubs.length >= 1) {
            selectedClub = caddieMasterClubs[0]
        }

        return {
            clubs: caddieMasterClubs,
            selectedClub: selectedClub,
        }
    }
);

